import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { ExtendedRoute } from '@hdms/shared/common-types';

export function parentRouteMatcher(
  consumed: UrlSegment[],
  { segments }: UrlSegmentGroup,
  route: ExtendedRoute
): UrlMatchResult {
  return segments[segments.length - 1].path === route.data.parentRoute ? { consumed } : null;
}
